import { StringUnionKeyAsValue } from '~commonInfra/utils/TypescriptHelpers';
import { IsNlpEnabled } from '~src/lens/utils/LensUtil';
import { isMetricsEnabled } from '~src/metrics/util/MetricUtils';

import { ExplorableItemType } from './ContentType';
import { ILuidItem } from './resourceParts';

/**
 * These are the types of "content items" that can be returned by the exploreContent API.
 * Only these item types can be displayed with each other in mixed content explorers.
 *
 * Table doesnt really belong here, added temporarily to enable set permission action before refactor this type
 */
export type ExploreContentApi_ContentType =
  |'project'
  |'workbook'
  |'datasource'
  |'view'
  |'flow'
  |'dataconnection'
  |'dataRole'
  |'lens'
  |'database'
  |'table'
  |'metric'
  |'collection'
  |'virtualConnection'
  |'virtualConnectionTable'
  |'virtualConnectionColumn'
  |'predictiveModel'
  ;


export const ExploreContentApi_ContentTypeValue: StringUnionKeyAsValue<ExploreContentApi_ContentType> = {
  project: 'project',
  workbook: 'workbook',
  datasource: 'datasource',
  view: 'view',
  flow: 'flow',
  dataconnection: 'dataconnection',
  dataRole: 'dataRole',
  lens: 'lens',
  // TODO: database and table are not ExploreContent API types. How can we get these back to ExplorableItemType?
  database: 'database',
  table: 'table',

  // TODO: collection is not ExploreContent API types.
  collection: 'collection',

  metric: 'metric',

  virtualConnection: 'virtualConnection',
  virtualConnectionTable: 'virtualConnectionTable',
  virtualConnectionColumn: 'virtualConnectionColumn',
  predictiveModel: 'predictiveModel',
};

export function isExploreContentApiContentType(itemType: string): itemType is ExploreContentApi_ContentType {
  if (itemType === 'metric') {
    return isMetricsEnabled();
  }
  if (itemType === 'lens' || itemType === 'dataRole') {
    return IsNlpEnabled();
  }
  return ExploreContentApi_ContentTypeValue.hasOwnProperty(itemType);
}

export function filterToContentTypes(values: string[]): ExploreContentApi_ContentType[] {
  if (values) {
    return values.filter(isExploreContentApiContentType);
  } else {
    return [];
  }
}

export interface IContent extends ILuidItem {
  id: string;
  contentType: ExplorableItemType;
  name: string;
  description?: string;
  ownerId: string;
  ownerName: string;
  createdAt: string;
  updatedAt: string;
  isFavorite?: boolean;
  favoritesTotal?: number;
  thumbnailUrl?: string;
  contentDetail?: string;
  tags?: string[];
  lastAccessedAt?: string;
  draftStatus?: string;
  draftId?: string;
  draftLuid?: string;
  extractDraftAvailable?: boolean;
  datasourceLuid?: string;
  projectName?: string;
  containerName?: string;
}
